import Button from "@pages/EverGreen/Components/Button";
import { InputGroup } from "@components/_Revamp/InputGroup";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription/TitleAndDescription";
import { styled } from "@linaria/react";
import useForm from "@utils/useForm";
import React, { useEffect, useState } from "react";
import { ITheme, themeDefault, useTheme } from "src/theme-revamp";
import { validate } from "./service";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { get, isEmpty } from "lodash";
import { SubmitSuccess } from "./components/SubmitSuccess";
import { setLoadingState } from "@redux/slices/loadingSlice";
import { Helpers } from "@utils/helpers";
import { postContactEvergreen } from "@api/index";
import Link from "@components/_Revamp/Link";
import Contactus from "@pages/EverGreen/Components/Contactus";
import { CONTAINER_SIZE, SCREEN_SIZE } from "@static/screen-size";
import MainContainer from "@pages/EverGreen/Components/Container";
import { ROUTE_PATH } from "@static/route-paths";
import { EverGreenStyle } from "@utils/Style/everGreen";
import {
  ContactInfo,
  updateContactDetail,
} from "@redux/slices/EVER_GREEN/contactSlice";
import { useHistory } from "react-router-dom";
import {
  initialState,
  updateMyInfoRecord,
} from "@redux/slices/EVER_GREEN/step2Slice";
import { css } from "@linaria/core";
import {
  trackOnFormStartOrSuccess,
  trackOnLoad,
} from "@pages/EverGreen/Helpers/analyticsHelper";

const SubmitNote = styled.p<{ theme: ITheme }>`
  color: ${(props) => props.theme.colors.grey[1400]};
  font-size: 12px;
  width: 100%;
  max-width: 744px;
  font-weight: 500;
  line-height: 19.2px;
  letter-spacing: 0.18px;
  span {
    color: ${EverGreenStyle.colors.primary};
    font-weight: 500;
    letter-spacing: 0.18px;
  }
  a {
    font-weight: 600;
    line-height: 19.2px;
    font-size: 12px;
    letter-spacing: 0.18px;
    color: ${EverGreenStyle.colors.primary};
    u {
      color: ${EverGreenStyle.colors.primary};
      border-bottom: 1px solid ${EverGreenStyle.colors.primary};
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    /* padding: 0 24px; */
  }
`;

const FormActionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 24px;
  margin-bottom: 64px;
`;

const ContacFormContainer = styled.div`
  margin: 0 auto 50px auto;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
    padding: 0 24px;
  }
`;

const ContactInputContainer = styled.div`
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  margin: 56px 0;
`;

const SpiltUpContainer = styled.div<{ mariginTop?: string }>`
  max-width: 100%;
  display: flex;
  margin-top: ${(props) => props.mariginTop || "0"};
  gap: 16px;
  & div {
    width: 100%;
    /* flex-grow: 1; */
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 0px;
    & div {
      display: flex;
      flex-direction: column;
      width: auto;
      flex-grow: 1;
      column-gap: 15px;
    }
  }
`;

export const createContactRequest = (
  form: ContactInfo,
  transactionId: number | string,
  agentCode: string | null = null,
  campaignCode: string = ""
) => {
  const content = {
    email: form.email,
    fullName: form.fullName,
    salutation: Helpers.getSalutationByCode(form.salutation || ""),
    dateOfBirth: form.dateOfBirth,
    mobileNumber: form.mobileNumber,
    agentCode: agentCode || form.agentCode,
  };

  return {
    transactionId,
    ...content,
    cc: campaignCode,
    dropPoint: "QNB_SPE_CONTACTUS",
    rentalPostalCustomer: "",
    product: "EVERGREEN",
  } as ContactInfo;
};

export const getTimestamp = () => {
  const pad = (i: number) => {
    return i < 10 ? "0" + i : i;
  };

  const d = new Date();
  const Y = d.getFullYear();
  const m = d.getMonth() + 1;
  const D = d.getDate();
  const H = d.getHours();
  const M = d.getMinutes();
  const S = d.getSeconds();
  const ms = ("00" + d.getMilliseconds()).slice(-3);
  return `` + Y + pad(m) + pad(D) + pad(H) + pad(M) + pad(S) + ms;
};

export const ContactForm = () => {
  const history = useHistory();
  const urlParams: URLSearchParams = Helpers.getURLSearchParams();
  const previousPage: string = urlParams.get("previous") || "";
  const title =
    previousPage === "reachLimit"
      ? "We have sold old the tranche for this cycle, join our waitlist!"
      : "We're here to help";
  const description =
    "Fill in your contact details and we'll be in touch to address your queries.";

  const theme = useTheme();

  const dispatch = useAvivaDispatch();
  const contactInfo = useAvivaSelector(
    (state) => state.everGreenContact.contactInfo
  );
  const basicDetails = useAvivaSelector((state) => state.everGreenStep2.myInfo);
  const transactionId = useAvivaSelector(
    (state) => state.everGreenStep1.transactionId || ""
  );

  const [formSubmited, setFormSubmited] = useState<boolean>(false);
  const agentCodeUrl =
    useAvivaSelector((state) => state.urlAnalytic?.param?.arc) || null;
  const agentCodeStore =
    useAvivaSelector((state) => state.everGreenStep3.FARData.code) || null;
  const myinfotransactionId = useAvivaSelector(
    (state) => state.everGreenStep2.myinfoTransactionId
  );
  const [isPageLoaded, setIsPageLoaded] = useState<boolean>();

  const { values, errors, handleChange, formValid, patchValue } = useForm(
    contactInfo,
    () => {},
    validate
  );
  const ContactUsUrl = get(window, "AVIVA_VARIABLE_CONFIG.avivaContactUsUrl");

  const agentCode = agentCodeUrl || agentCodeStore || urlParams.get("arc");
  const campaignCode = useAvivaSelector(
    (state) => state.loading.campaignDetail?.campaignCode || ""
  );

  const onInputChange = (fieldName: keyof ContactInfo, e: any) => {
    const value =
      fieldName === "fullName"
        ? e.target.value.replace(/[^a-z\s]/gi, "")
        : e.target.value;
    console.log("onInputChange", value);
    dispatch(updateContactDetail({ [fieldName]: value }));
    handleChange(e);
  };

  const onSubmit = async () => {
    dispatch(setLoadingState(true));
    setFormSubmited(true);
    console.log("values", values);
    const payload: any = createContactRequest(values, transactionId, agentCode?.replaceAll(" ","") || agentCode, campaignCode);
    try {
      const response = await postContactEvergreen(payload);
      console.debug(response);
      Helpers.clearCached();
      dispatch(setLoadingState(false));
      trackOnFormStartOrSuccess("DS_contact_us_form", true);
    } catch (error) {
      console.error(error);
      trackOnLoad({
        errorPage: { errorCode: "500", errorMsg: "contact us api call failed" },
      });
      dispatch(setLoadingState(false));
    }
  };

  useEffect(() => {
    if (isPageLoaded === undefined) {
      const hasMyInfo = basicDetails.customerId;
      setIsPageLoaded(true);
      if (hasMyInfo) {
        patchValue({
          fullName: basicDetails?.fullName,
          mobileNumber: basicDetails?.mobileNum,
          email: basicDetails?.emailId,
          salutation: basicDetails?.salutation,
        });
      }
    }
  }, [
    basicDetails.customerId,
    basicDetails?.emailId,
    basicDetails?.fullName,
    basicDetails?.mobileNum,
    basicDetails?.salutation,
    isPageLoaded,
    patchValue,
  ]);

  //AA on load
  useEffect(() => {
    trackOnLoad();
  }, []);

  return !formSubmited ? (
    <MainContainer
      backButtonFunction={() => {
        switch (previousPage) {
          case "landing":
            history.push(ROUTE_PATH.EVER_GREEN_GET_STARTED);
            break;
          case "myInfo":
            dispatch(updateMyInfoRecord(initialState.myInfo));
            history.push(ROUTE_PATH.EVER_GREEN_GET_STARTED);
            break;
          default:
            history.goBack();
            break;
        }
      }}
    >
      <>
        <div>
          <TitleAndDescription
            title={title}
            description={description}
            margin="0"
          />
        </div>
        <ContacFormContainer>
          <ContactInputContainer>
            <SpiltUpContainer>
              <InputGroup
                labelColor="#434343"
                id="salutation"
                name="salutation"
                label="Salutation"
                inputType="dropdown"
                onChange={(e) => {
                  trackOnFormStartOrSuccess("DS_contact_us_form");
                  onInputChange("salutation", e);
                }}
                placeholder="Please select"
                dropdownProps={{
                  value: values["salutation"] || basicDetails?.salutation,
                  source: [
                    { id: "Mr", label: "Mr" },
                    { id: "Mrs", label: "Mrs" },
                    { id: "Ms", label: "Ms" },
                    { id: "Master", label: "Master" },
                    { id: "Mdm", label: "Mdm" },
                    { id: "Dr", label: "Dr" },
                  ],
                }}
                theme={EverGreenStyle}
              />
              <InputGroup
                labelColor="#434343"
                id="fullName"
                name="fullName"
                label="Full Name"
                placeholder="John"
                onChange={(e: any) => {
                  trackOnFormStartOrSuccess("DS_contact_us_form");

                  onInputChange("fullName", e);
                }}
                invalid={!isEmpty(errors?.fullName?.message)}
                errorMessage={errors?.fullName?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["fullName"] || basicDetails?.fullName,
                }}
                inputType={"input"}
                theme={EverGreenStyle}
                onBlurShowError={true}
              />
            </SpiltUpContainer>
            <SpiltUpContainer mariginTop="48px">
              <InputGroup
                inputPropsForInputBox={{
                  inputMode: "tel",
                  inputType: "tel",
                }}
                id="mobileNumber"
                name="mobileNumber"
                label="Mobile Number"
                placeholder=""
                mobCode="+65"
                theme={EverGreenStyle}
                onChange={(e) => {
                  trackOnFormStartOrSuccess("DS_contact_us_form");

                  if (/^(8|9){1}[0-9]{0,7}$/.test(e.target.value))
                    onInputChange("mobileNumber", e);
                }}
                invalid={!Boolean(errors?.mobileNumber?.isValid)}
                errorMessage={
                  errors?.mobileNumber?.message ||
                  "Enter a valid 8-digit Singapore mobile number"
                }
                inputProps={{
                  textAlign: "left",
                  value: values["mobileNumber"] || basicDetails?.mobileNum,
                }}
                inputType={"input"}
                onBlurShowError
              />
              <InputGroup
                labelColor="#434343"
                id="email"
                name="email"
                label="Email"
                placeholder="John@singlife.com"
                onChange={(e) => {
                  trackOnFormStartOrSuccess("DS_contact_us_form");

                  onInputChange("email", e);
                }}
                invalid={!isEmpty(errors?.email?.message)}
                errorMessage={errors?.email?.message}
                inputProps={{
                  textAlign: "left",
                  value: values["email"] || basicDetails?.emailId,
                }}
                onBlurShowError={true}
                inputType={"input"}
                theme={EverGreenStyle}
              />
            </SpiltUpContainer>
          </ContactInputContainer>
          <FormActionContainer>
            <Button
              width="180px"
              variant="default"
              label="Submit"
              disabled={!formValid}
              theme={EverGreenStyle}
              onClick={onSubmit}
            />
          </FormActionContainer>
          <SubmitNote theme={theme}>
            By clicking "Submit", you consent to Singapore Life Ltd.
            ("Singlife") collecting, processing, disclosing and/or transferring
            your personal data (provided in this form) to Singlife related group
            of companies, third party service providers and/or intermediaries
            (including your financial adviser, where applicable), whether
            located in Singapore or elsewhere, for the following purposes:
            <br />
            <br />
            (i) to contact you via call, email and messages on any messaging
            platform (including SMS) for the processing of your request; and
            <br />
            <br />
            (ii) for statistical, research, audit, compliance and regulatory
            purposes.
            <br />
            <br />
            Refer to{" "}
            <Link
              theme={themeDefault}
              target="_blank"
              rel="noopener noreferrer"
              url={ContactUsUrl}
              text={`Singlife's Data Protection Notice`}
            />{" "}
            for more details. Should you wish to withdraw your consent, you may
            contact Singlife at{" "}
            <Link
              theme={themeDefault}
              url="mailto:cs_life@singlife.com"
              text="cs_life@singlife.com"
            />{" "}
            or{" "}
            <Link
              theme={themeDefault}
              url="tel:+6568279933"
              text="+65 6827 9933"
            />
            .
          </SubmitNote>
          <Contactus
            descriptionClass={descriptionClass}
            findoutLink={{ default: 14, tablet: 14 }}
            color={EverGreenStyle.colors.primary}
            cardLinkClass={{ default: 14, tablet: 14 }}
            cardInfoHeadingClass={font18}
          />
        </ContacFormContainer>
      </>
    </MainContainer>
  ) : (
    <SubmitSuccess />
  );
};
export default ContactForm;

const descriptionClass = css`
  font-size: 14px;
`;
const font18 = css`
  font-size: 18px;
`;
